// import { API_URL_ROOT } from "./constant.js";
import axios from "axios";
// import * as Cookie from "./Cookie";
import { generateToken } from "util/token";

//Post call
export async function post(url, postData, timeout = 3000) {
  const JWT_TOKEN = await generateToken();
  let postConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + JWT_TOKEN,
    },
  };
  const httpClient = axios.create();
  httpClient.defaults.timeout = timeout;
  return await httpClient.post(url, postData, postConfig);
}

//Put call
export async function put(url, postData, timeout = 3000) {
  const JWT_TOKEN = await generateToken();
  let postConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + JWT_TOKEN,
    },
  };
  const httpClient = axios.create();
  httpClient.defaults.timeout = timeout;
  return await httpClient.put(url, postData, postConfig);
}

//Get call
export async function get(url, timeout = 3000) {
  const JWT_TOKEN = await generateToken();
  let getConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + JWT_TOKEN,
    },
  };
  const httpClient = axios.create();
  httpClient.defaults.timeout = timeout;
  return await httpClient.get(url, getConfig);
}
export async function postgraphql(url, postData, timeout = 3000) {
  const JWT_TOKEN = await generateToken();
  let postConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + JWT_TOKEN,
    },
  };
  const httpClient = axios.create();
  httpClient.defaults.timeout = timeout;
  return await httpClient.post(url, postData, postConfig);
}
